/* eslint-disable @typescript-eslint/no-explicit-any -- Service with dynamic external data */
import { AutonomousIntelligence } from '@/services/intelligence/AutonomousIntelligence';
import { wrapTool, toolSuccess } from '../utils/ToolUtils';
import type { AnyToolFunction } from '../types';

// ============================================================================
// Types for NarrativeTools
// ============================================================================

export const NarrativeTools = {
    generate_visual_script: wrapTool('generate_visual_script', async (args: { synopsis: string }) => {
        const systemPrompt = `
You are a master filmmaker and narrative structuralist.
Your task is to convert a raw synopsis into a structured 9-beat visual script.
Focus on visual storytelling, camera angles, and emotional beats.

Return ONLY a valid JSON object with the following structure:
{
  "title": "String",
  "logline": "String",
  "beats": [
    {
      "beat": 1,
      "name": "Establishment",
      "description": "Visual description of the scene.",
      "camera": "Shot type (e.g., Wide, Close-up)",
      "mood": "Lighting/Atmosphere"
    },
    ... (up to 9 beats)
  ]
}
`;
        const prompt = `Synopsis: ${args.synopsis}`;

        const schema = {
            type: "object" as const,
            nullable: false,
            properties: {
                title: { type: "string" as const, nullable: false },
                logline: { type: "string" as const, nullable: true },
                beats: {
                    type: "array" as const,
                    nullable: false,
                    items: {
                        type: "object" as const,
                        nullable: false,
                        properties: {
                            beat: { type: "number" as const, nullable: false },
                            name: { type: "string" as const, nullable: false },
                            description: { type: "string" as const, nullable: false },
                            camera: { type: "string" as const, nullable: true },
                            mood: { type: "string" as const, nullable: true }
                        },
                        required: ["beat", "name", "description"] as const
                    }
                }
            },
            required: ["title", "beats"] as const
        };

        const response = await AutonomousIntelligence.generateStructuredData(
            [{ text: prompt }],
            schema,
            undefined,
            systemPrompt
        ) as { title: string; beats: any[]; logline?: string };

        return toolSuccess(response, `Successfully generated a visual script: ${response.title}`);
    })
} satisfies Record<string, AnyToolFunction>;
